import React, { useEffect, useRef, useState } from "react";
import { getEnvUrl, getToken } from "../../../utils/Api";
import CreateBanner from "./popups/createBanner"; 
import ViewBanner from "./popups/viewBanner";
import Loader from "../../common/loader";
import {deleteBanner} from "../../../Services/marketingBannersServices"
import { toast } from 'react-toastify'; 
import { checkPermissions } from "../../../Services/User/User";
import { useNavigate } from "react-router-dom";
const $ = require("jquery");
require("datatables.net");

const MarketingBanners = ({ data }) => {
  const tableRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [createBannerModal, setCreateBannerModal] = useState(false); 
  const [viewBannerModal, setViewBannerModal] = useState(false);
  const [selectedCampaignType, setSelectedCampaignType] = useState("");
  const [dataTableInstance, setDataTableInstance] = useState(null);
  const [rrender, setRender] = useState(null);
  const [popupType, setPopupType] = useState('CREATE');
  const [bannerId, setBannerId] = useState('');
  const navigate = useNavigate();
  
  const createBannerModalClose = () => {
    setCreateBannerModal(false);
  };
   
  const viewBannerModalClose = () => {
    setViewBannerModal(false);
  };

 

  const reRender =()=>{ 
    setRender(!rrender)
  }
    useEffect(() => {
    if(!checkPermissions('marketing_banners_page') || !checkPermissions('games_navigation')){ 
        navigate('/')
      }
    },[])

  useEffect(() => {
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      serverMethod: "get",
      ajax: {
        url: `${getEnvUrl()}/admin/game/getBannersReport?campaigntype=${selectedCampaignType}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      },
      columns: [
        { data: "banners_id" },
        { data: "gamename" }, 
        {
          data: null,
          title: "Image",
          render: (data, type, row) => (
            `<div>
             <img style='width: 200px' src='${getEnvUrl()}/game/getBannerimg?type=${row?.campaign_type}&id=${btoa(btoa(row?.banners_id))}&hash=${Date.now()}'>
             </div>`
          ),
        },

        { data: "campaign_type" },
        { data: "active" },
        {
          data: null,
          title: "Actions",
          render: (data, type, row) => (
            `<div>
              <span class="a-edit"><i class="bi bi-pencil-square"></i></span>
              <span class="a-view"><i class="bi bi-eye-fill"></i></span>
              <span class="a-delete" banners_id="${row.banners_id}"><i class="bi bi-trash-fill"></i></span>
            </div>`
          ),
        },
      ],
      createdRow: (row, data, dataIndex) => {
        if(!checkPermissions('marketing_banner_edit')){
          $(row).find('.a-edit').remove();
        }
        if(!checkPermissions('marketing_banner_view')){
          $(row).find('.a-view').remove();
        }
        if(!checkPermissions('marketing_banner_delete')){
          $(row).find('.a-delete').remove();
        }
        $(row)
          .find(".a-edit")
          .on("click", () => { 
            setBannerId(data.banners_id)
            setPopupType('EDIT');
            setCreateBannerModal(true)
          });
        $(row)
          .find(".a-view")
          .on("click", () => {
            setBannerId(data.banners_id)
            setViewBannerModal(true);
          });
        $(row).find(".a-delete").on("click", function () { 
          if(window.confirm('Are you sure to delete?')){
            deleteBanner(data.banners_id).then((data)=>{
              if(data.status){
                reRender()
                toast.success(data.message)
              }else{
                toast.error(data.errorMessage)
              }
           })
          } 
        });
      },
      columnDefs: [
        {
          targets: [2,5],
          orderable: false,
        },
      ],
      aaSorting: [[0, "desc"]],
      drawCallback: function (settings) {
        setIsLoading(false);
      },
    });

    setDataTableInstance(table);

    return () => {
      if (table) {
        table.destroy();
      }
    };
  }, [data, selectedCampaignType,rrender]);

  const handleCampaignTypeChange = (event) => {
    const { value } = event.target;
    setSelectedCampaignType(value);
  };
//   const handleCampaignReset = () => {
//    document.getElementById("bannercampaigntype").value = "";
//    // bannerdatatable();
//  };
const handleCampaignReset = () => {
   document.getElementById("bannercampaigntype").value = "";
   setSelectedCampaignType("");
   if (dataTableInstance) {
     dataTableInstance.ajax.reload();
   }
 };
 

  return (
    <div>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Marketing Banners</h1>
        </div>
        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card p-10">
                <h5 className="card-title ">
                  {
                    checkPermissions("marketing_banner_create") && 
                    <button
                    id="addbannerid"
                    type="button"
                    className="btn btn-primary float-right"
                    onClick={() => {setPopupType('CREATE');setCreateBannerModal(true);}}
                  >
                    + Add banner
                  </button>
                  }
                 
                </h5>
                <div className="row-g-1 mb-10">
                  <div className="row">
                    <div className="col-sm-3">
                      <div className="form-group">
                        <div className="input-group">
                          <select
                            id="bannercampaigntype"
                            className="form-control"
                            onChange={handleCampaignTypeChange}
                          >
                            <option value="">--Select Campaign Type --</option>
                            <option value="MOBILE">MOBILE</option>
                            <option value="WEB">WEB</option>
                            <option value="TV">TV</option>
                          </select>
                          <span className="input-group-btn">
                            <button className="btn btn-primary" id="gameReset" onClick={handleCampaignReset}>Reset</button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {isLoading ? <Loader /> : ""}
                <div className={isLoading ? "card-body hide" : "card-body"}>
                  <table
                    className="table table-striped table-hover table-bordered no-footer dataTable"
                    width="100%"
                    ref={tableRef}
                  >
                    <thead>
                      <tr>
                        <th>Banner Id</th>
                        <th>Banner name</th>
                        <th>Image</th>
                        <th>Campaign type</th>
                        <th>Active</th>
                        <th>Action </th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      {createBannerModal ? <CreateBanner popupType={popupType} bannerId={bannerId} reRender={reRender} isShow={createBannerModal} close={createBannerModalClose} /> : ""}
       {viewBannerModal ? <ViewBanner bannerId={bannerId} isShow={viewBannerModal} close={viewBannerModalClose} /> : ""}
    </div>
  );
};

export default MarketingBanners;